export class Report {
  constructor() {}
}
